import type { AuthenticatedUser } from '@unifemga/shared';

/**
 * Where a signed-in person belongs.
 *
 * One definition, because the header, the sign-in screen and the registration
 * screen all need it and would otherwise disagree about where an administrator
 * lands.
 */
export function homePathFor(user: Pick<AuthenticatedUser, 'isAdmin'> | null): string {
  return user?.isAdmin ? '/admin' : '/portal';
}
